import React from 'react';
import { Attachment } from '@teetsh/app/src/types/attachment';
import { AcceptOnly, useDropzone } from './useDropzone';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { BaseButtonProps } from '@teetsh/app/src/components/Buttons/BaseButtonProps';
import { useTranslation } from 'react-i18next';

interface Props {
  onChange: (v: Attachment[]) => void;
  label?: string;
  attachments?: Attachment[];
  uploadingAttachment?: boolean;
  handleError: ({ message }: { message: string }) => void;
  handleUploadAttachment: (payload: { file: File }) => Promise<any>;
  icon?: any;
  multiple?: boolean;
  acceptOnly?: AcceptOnly;
}

export default function ButtonAttachment(props: Props & BaseButtonProps) {
  const { t } = useTranslation(['common']);
  const {
    attachments = [],
    uploadingAttachment = false,
    label = t('common:buttons.attachDocuments'),
    onChange,
    icon,
    handleUploadAttachment,
    handleError,
    multiple,
    acceptOnly,
    ...rest
  } = props;

  const { getRootProps, getInputProps } = useDropzone({
    handleUploadAttachment,
    handleError,
    attachments,
    onChange,
    multiple,
    acceptOnly,
  });

  const { ref, ...rootProps } = getRootProps();
  return (
    <Button
      {...(rootProps as any)}
      innerRef={ref}
      icon={icon}
      loading={uploadingAttachment}
      data-testid="attachments"
      {...rest}
    >
      <span data-testid="attachment-area">
        <input {...(getInputProps() as any)} data-testid="attachment-input" />
        {label}
      </span>
    </Button>
  );
}
